import { combineReducers } from 'redux';
import { History } from 'history';
import { connectRouter } from 'connected-react-router';
import { dashboardReducer } from './dashboard-reducer';
import { State } from '../state';
import { legalReducer } from './legal-reducer';
import { navigationReducer } from './navigation-reducer';
import { authReducer } from './auth-reducer';
import { registrationReducer } from './registration-reducer';
import { userSettingsReducer } from './user-settings-reducer';
import { timelineExportReducer } from './timeline-export-reducer';
import { signalrConnectionReducer } from './signalr-connection-reducer';
import { trendExportReducer } from './trend-export-reducer';
import { alarmAcknowledgeReducer } from './alarm-acknowledge-reducer';
import { siteReducer } from './site-reducer';
import { SierraDeviceReducer } from './sierra-device-reducer';
import { PxdbDeviceReducer } from './pxdb-device-reducer';
import { MeshDeviceReducer } from './mesh-device-reducer';
import { StarfishDeviceReducer } from './starfish-device-reducer ';
import { trendChannelReducer } from './trend-channel-reducer';
import { GetSubscriptionReducer } from './get-subscription-reducer';
import { alarmSuggestionReducer } from './alarm-suggestion-reducer';
import { resetUserSuggestionReducer } from './reset-suggestion-reducer';
import { sensorDetailReducer } from './sensor-detail-reducer';
import { GetOrgCheckReducer } from './get-org-check-reducer';
import { manageAlarmsReducer } from './manage-alarms-reducer';
import { manageDeviceProfilesReducer } from './manage-deviceprofiles-reducer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Reducer = (history: History<any>): any =>
    combineReducers<State>({
        // The following broke in a new version of something related to react-router.
        // Might have ben type types file for one of those libraries. It came up
        // when 'npm install' on CI brought in a newer version, and then we upgraded
        // to get the same version because 'yarn install' doesn't work in CI. Using
        // "as any" to get around the type problem. Things seem to work just fine.
        router: connectRouter(history) as any, // eslint-disable-line @typescript-eslint/no-explicit-any
        Authentication: authReducer,
        Dashboard: dashboardReducer,
        Legal: legalReducer,
        Navigation: navigationReducer,
        Registration: registrationReducer,
        User: userSettingsReducer,
        TimelineExport: timelineExportReducer,
        SignalRConnection: signalrConnectionReducer,
        TrendExport: trendExportReducer,
        AlarmAcknowledgement: alarmAcknowledgeReducer,
        Site: siteReducer,
        SierraDevice: SierraDeviceReducer,
        StarfishDevice: StarfishDeviceReducer,
        SelectedTrendChannels: trendChannelReducer,
        MeshDevice: MeshDeviceReducer,
        GetSubscription: GetSubscriptionReducer,
        GetOrgCheck: GetOrgCheckReducer,
        AlarmSuggestion: alarmSuggestionReducer,
        ResetUserSuggestion: resetUserSuggestionReducer,
        SensorDetailReport: sensorDetailReducer,
        PxdbDevice: PxdbDeviceReducer,
        ManageAlarms: manageAlarmsReducer,
        ManageDeviceProfiles: manageDeviceProfilesReducer,
    });

export default Reducer;
